import { el } from '../lib/dom.js';

const prettify = (s) => s.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

/**
 * Wild encounter locations for the selected game, from
 * /pokemon/{id}/encounters. PokéAPI has no map imagery or coordinates, so
 * this is a grouped text list: area, level range, method, best odds.
 */
export function Locations(encounters, versionNames) {
  const wanted = new Set(versionNames);
  const areas = [];

  for (const row of encounters) {
    const details = row.version_details.filter((v) => wanted.has(v.version.name));
    if (!details.length) continue;

    let min = Infinity;
    let max = -Infinity;
    let best = 0;
    const methods = new Set();
    const conditions = new Set();
    for (const v of details) {
      best = Math.max(best, v.max_chance || 0);
      for (const d of v.encounter_details) {
        min = Math.min(min, d.min_level);
        max = Math.max(max, d.max_level);
        if (d.method?.name) methods.add(prettify(d.method.name));
        for (const c of d.condition_values || []) conditions.add(prettify(c.name));
      }
    }
    areas.push({
      name: prettify(row.location_area.name),
      levels: min === max ? `Lv ${min}` : `Lv ${min}–${max}`,
      methods: [...methods].join(', '),
      conditions: [...conditions].join(', '),
      best,
    });
  }

  if (!areas.length) {
    return el(
      'p',
      { class: 'detail__muted' },
      'Not found in the wild in this game — it may be a gift, evolution, trade, fossil, or event Pokémon.',
    );
  }

  areas.sort((a, b) => b.best - a.best);

  return el(
    'ul',
    { class: 'locations' },
    ...areas.map((a) =>
      el(
        'li',
        { class: 'locations__item' },
        el('span', { class: 'locations__area' }, a.name),
        el('span', { class: 'locations__meta' }, a.levels),
        el('span', { class: 'locations__meta' }, a.methods),
        a.conditions ? el('span', { class: 'locations__cond' }, a.conditions) : null,
        a.best ? el('span', { class: 'locations__rate' }, `${a.best}%`) : null,
      ),
    ),
  );
}
